export default __webpack_public_path__ + "static/media/qr.2fbb0018.jpg";